import { call, fork, put, select, takeEvery } from 'redux-saga/effects'
import {
  CHANGE_FILTER_STATE,
  LOAD_USERS,
  LOAD_USERS_FAILED,
  LOAD_USERS_SUCCESS,
} from './users-actions'

import { RootState } from 'store/store'
import { UserProfile } from 'types/userTypes'
import { HttpClient } from '../../../services/HttpClient'
import { UsersFilterState } from '../components/types'
import { prepareQuery } from './users-service'

type ErrorResponse = { message: string }

export const getFilterState = (state: RootState) =>
  state.usersReducer.userFilters

function* loadUsers() {
  try {
    const filterState: UsersFilterState = yield select(getFilterState)

    const query = prepareQuery(filterState)

    const data: ErrorResponse | UserProfile[] = yield call(() => {
      return HttpClient.get(
        `/api/secured/user-profiles/scroll?${query}order.${filterState.sort}=${
          filterState.sortDirection
        }&pageNum=${filterState.pageNum || 0}&pageSize=${
          filterState.pageSize || 10
        }`
      )
    })

    const countData: { count: number } = yield call(() => {
      return HttpClient.get(
        `/api/secured/user-profiles/count?organizationName=${
          filterState.organizationName
            ? `*${filterState.organizationName}*`
            : ''
        }&email=${filterState.email ? `*${filterState.email}*` : ''}`
      )
    })

    if ((data as ErrorResponse).message) {
      yield put(LOAD_USERS_FAILED((data as ErrorResponse).message))
    } else {
      yield put(LOAD_USERS_SUCCESS(data as UserProfile[], countData.count))
    }
  } catch (e: any) {
    yield put(LOAD_USERS_FAILED(e.message))
  }
}

function* loadUsersListSaga() {
  yield takeEvery(CHANGE_FILTER_STATE.getType(), loadUsers)
  yield takeEvery(LOAD_USERS.getType(), loadUsers)
}

export default function* usersSaga() {
  yield fork(loadUsersListSaga)
}
